export const hasKeys = <T>(v: T): v is T extends undefined ? never : T =>
  typeof v !== 'undefined' && !!Object.keys(v || {}).length;

export const isArray = (val: any): val is any[] => val && Array.isArray(val);

export const isSysError = (error: any): error is Error =>
  error?.message !== undefined && error.stack;

export const isFunc = (func: any) => typeof func === 'function';

export const isNumber = (val: any): val is number => typeof val === 'number';

export const isNull = (val: any): val is null => val === null;

export const isUndefined = (val: any): val is undefined =>
  typeof val === 'undefined';

export const isNullOrUndefined = (val: any): val is null | undefined => {
  if (isUndefined(val)) return true;
  if (isNull(val)) return true;
  return false;
};

export const isObject = <S>(
  val: S
): val is Exclude<S, string | number | boolean | null | undefined> =>
  typeof val === 'object';

export const isString = (val: any): val is string => typeof val === 'string';

export const isStringArray = (val: any): val is string[] =>
  Array.isArray(val) && val.every((it) => typeof it === 'string');
